import React, { useEffect, useState } from "react";
import {
  Link as ChakraLink,
  Box,
  Image,
  Button,
  Flex,
  useBreakpointValue,
} from "@chakra-ui/react";

import i1 from "../assets/instagram/img1.jpg";
import i2 from "../assets/instagram/img2.jpg";
import i3 from "../assets/instagram/img3.jpg";
import i4 from "../assets/instagram/img4.jpg";
import i5 from "../assets/instagram/img5.jpg";
import i7 from "../assets/instagram/img7.jpg";
import i8 from "../assets/instagram/img8.jpg";
import i9 from "../assets/instagram/img9.jpg";
import i10 from "../assets/instagram/img10.jpg";
import i11 from "../assets/instagram/img11.jpg";
import i12 from "../assets/instagram/img12.jpg";

const imageUrls = [i1, i2, i3, i4, i5, i7, i8, i9, i10, i11, i12];

const Instagram = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalImages = imageUrls.length;
  const scrollDelay = 2000;

  // Responsive values
  const visibleImages = useBreakpointValue({ base: 1, md: 5 });
  const imageWidth = useBreakpointValue({ base: 260, md: 220 });
  const baseGap = useBreakpointValue({ base: 16, md: 32 });
  const enableScaling = useBreakpointValue({ base: false, md: true });

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalImages);
    }, scrollDelay);

    return () => clearInterval(interval);
  }, [totalImages]);

  const carouselImages = [...imageUrls, ...imageUrls];

  return (
    <Box bg="#E0DBD4" py={10} px={4} overflow="hidden">
      <Box
        overflow="hidden"
        width={`${(imageWidth + baseGap) * (visibleImages || 1)}px`}
        mx="auto"
      >
        <Flex
          transform={`translateX(-${(imageWidth + baseGap) * currentIndex}px)`}
          transition="transform 0.3s ease-in-out"
          width="max-content"
        >
          {carouselImages.map((src, index) => {
            const logicalIndex = index % totalImages;
            const center = (currentIndex + Math.floor((visibleImages || 1) / 2)) % totalImages;
            const prev = (center - 1 + totalImages) % totalImages;
            const next = (center + 1) % totalImages;

            let scale = 0.9;
            let marginX = `${baseGap / 2}px`;

            if (enableScaling) {
              if (logicalIndex === center) {
                scale = 1.35;
                marginX = `${baseGap}px`;
              } else if (logicalIndex === prev || logicalIndex === next) {
                scale = 1.1;
                marginX = `${baseGap}px`;
              } else {
                marginX = `${baseGap / 3}px`;
              }
            }

            return (
              <Box
                key={index}
                flex="0 0 auto"
                width={`${imageWidth}px`}
                mx={marginX}
                zIndex={enableScaling && logicalIndex === center ? 3 : 1}
              >
                <Box
                  transform={`scale(${scale})`}
                  transition="transform 0.4s ease"
                  borderRadius="md"
                  overflow="hidden"
                >
                  <Image
                    src={src}
                    alt={`Instagram ${index}`}
                    width="100%"
                    height="auto"
                    objectFit="cover"
                    borderRadius="md"
                    shadow="xl"
                  />
                </Box>
              </Box>
            );
          })}
        </Flex>
      </Box>

      <Flex justify="center" mt={8}>
        <ChakraLink
          href="https://www.instagram.com/rrumidiamond/#"
          isExternal
          _hover={{ textDecoration: "none" }}
        >
          <Button
            bg="#012E2D"
            color="white"
            _hover={{ bg: "#014847" }}
            px={8}
            py={6}
            fontSize="md"
            borderRadius="md"
          >
            Follow us on instagram
          </Button>
        </ChakraLink>
      </Flex>
    </Box>
  );
};

export default Instagram;
